import ToursReviewScreen from '../(tabs)/tours/review/[bookingId]'
import { seedToursPreview } from '../../preview/seed'
import { PreviewSeedBoundary } from '../../preview/PreviewSeedBoundary'

export default function PreviewReviewRoute() {
  return (
    <PreviewSeedBoundary seed={seedToursPreview} seedKey="review">
      <ToursReviewScreen />
    </PreviewSeedBoundary>
  )
}
